import { useParams } from "react-router-dom";

function FatooraBanner() {
    const { lang } = useParams();

    const slide = {
        image: '/images/zatca-logo.svg',
        title: 'Saudi Arabia Fatoora Phase II',
        description: 'Integration is now available! Click ',
        link: `/${lang}/plugins/fatoora`
    };

    return (
        <div className="relative w-full overflow-hidden">
            <section className="min-w-full py-4 bg-green-800 shadow-lg flex flex-col items-center text-center justify-center px-4 md:px-8">
                <a href={slide.link} className="inline-block" data-analytics-event="fatoora-home-banner-image">
                    <img
                        alt={slide.title}
                        src={slide.image}
                        className="mx-auto h-12 md:h-16 transition-transform duration-300 hover:scale-110"
                    />
                </a>
                <p className="text-white text-sm md:text-base">{slide.title} {' '} {slide.description}
                <a href={slide.link} className="underline text-white font-semibold hover:text-green-100" data-analytics-event="fatoora-home-banner-link">
                        here
                </a>
                    {' '}to start using it today!
                </p>
                
            </section>
        </div>
    );
}

export default FatooraBanner;